import { Tab, Tabs } from "@blueprintjs/core"
import { observer } from "mobx-react"
import { Page } from "modules/common/components/page/Page"
import func from "modules/orders-manage/functionalities"
import { menuItems } from "modules/root/components/menu/MainMenu"
import { canAny } from "modules/session/auth/access"
import { SessionType } from "modules/session/auth/models/session"
import React, { useEffect } from "react"
import { useParams } from "react-router-dom";
import { OrderQuestionStoreType } from "../models/store"
import styles from "./QuestionsPage.module.scss"
import { QuestionsTab } from "./Tab"

const menu = menuItems()

export const OrderQuestionsPage: React.FC<OrderQuestionsPageProps> = observer(({ store, session }) => {
  const canManage = canAny([func.ORDERS_QUESTION_EDIT, func.ORDERS_QUESTION_FULL_ACCESS], session.access)

  // задание из пути /order-questions/<id>: открывается сразу на своей доске
  const { questionId = "" } = useParams<{ questionId?: string }>()

  // вкладка браузера называется по открытому заданию: закладка на него узнаваема
  const opened = questionId && store.question.id === questionId ? store.question.number : ""

  useEffect(() => {
    document.title = opened ? `${menu.orderQuestions.label} — ${opened}` : menu.orderQuestions.label
  }, [opened])

  return (
    <Page className={styles.page}>
      <Tabs
        className={`${styles.tabs} planr-tabs-navigation`}
        id="OrderQuestionsPage"
        selectedTabId="1"
        renderActiveTabPanelOnly={true}
      >
        <Tab
          id="1"
          title={menu.orderQuestions.label}
          panel={
            <QuestionsTab
              store={store}
              currentUserId={session.userId}
              canManage={canManage}
              canAddQuestion={canManage}
              questionId={questionId}
              isActiveTab
            />
          }
        />
      </Tabs>
    </Page>
  )
})

interface OrderQuestionsPageProps {
  store: OrderQuestionStoreType
  session: SessionType
}
